module.exports = __webpack_public_path__ + "img/ic-draw-down.24a785e8.svg";